import React from 'react';

// Fixed confetti positions so they don't re-randomize on every render
const CONFETTI = [
  { left:'8%',  top:'12%', color:'#FF0033' },
  { left:'22%', top:'5%',  color:'#FFD700' },
  { left:'38%', top:'18%', color:'#fff'    },
  { left:'55%', top:'7%',  color:'#FF0033' },
  { left:'70%', top:'15%', color:'#FFD700' },
  { left:'85%', top:'9%',  color:'#fff'    },
  { left:'92%', top:'28%', color:'#FF0033' },
  { left:'78%', top:'38%', color:'#FFD700' },
  { left:'5%',  top:'35%', color:'#fff'    },
  { left:'15%', top:'55%', color:'#FF0033' },
  { left:'88%', top:'55%', color:'#fff'    },
  { left:'3%',  top:'70%', color:'#FFD700' },
  { left:'20%', top:'82%', color:'#FF0033' },
  { left:'45%', top:'88%', color:'#fff'    },
  { left:'62%', top:'80%', color:'#FFD700' },
  { left:'80%', top:'75%', color:'#FF0033' },
  { left:'93%', top:'80%', color:'#fff'    },
  { left:'50%', top:'3%',  color:'#FFD700' },
  { left:'35%', top:'92%', color:'#FF0033' },
  { left:'75%', top:'92%', color:'#fff'    },
];

function CakeIcon() {
  return (
    <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="#073E81"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"/>
      <path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1"/>
      <path d="M2 21h20"/>
      <path d="M7 8v3"/>
      <path d="M12 8v3"/>
      <path d="M17 8v3"/>
      <path d="M7 4 Q7.5 2 8 4"/>
      <path d="M12 4 Q12.5 2 13 4"/>
      <path d="M17 4 Q17.5 2 18 4"/>
    </svg>
  );
}

export default function BirthdayModal({ userName, session, onDismiss }) {
  // session: 'morning' | 'evening'
  const greeting = session === 'evening'
    ? 'Hope you had a wonderful day!'
    : 'Have an amazing day ahead!';

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'linear-gradient(135deg, #073E81 0%, #0a56b3 60%, #073E81 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      {CONFETTI.map((c, i) => (
        <div key={i} style={{
          position: 'absolute', width: 10, height: 10, borderRadius: '50%',
          background: c.color, left: c.left, top: c.top, opacity: 0.55,
          transform: `scale(${0.6 + (i % 3) * 0.4})`,
        }}/>
      ))}

      <div style={{
        background: '#fff', borderRadius: 24, padding: '48px 52px',
        textAlign: 'center', maxWidth: 440, width: '90%',
        boxShadow: '0 32px 80px rgba(0,0,0,0.35)', position: 'relative',
      }}>
        {/* Red accent bar at top */}
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 5,
          background: '#FF0033', borderRadius: '24px 24px 0 0',
        }}/>

        <div style={{ marginBottom: 20 }}><CakeIcon /></div>

        <div style={{
          fontSize: 11, fontWeight: 700, color: '#FF0033',
          letterSpacing: 3, marginBottom: 10,
        }}>
          8D STUDIOS WISHES YOU
        </div>

        <h1 style={{
          fontSize: 38, fontWeight: 800, color: '#073E81',
          margin: '0 0 10px', lineHeight: 1.1,
        }}>
          Happy Birthday!
        </h1>

        <p style={{
          fontSize: 16, color: '#444', margin: '0 0 8px', lineHeight: 1.6,
        }}>
          {userName}, you're an incredible part of our team.
        </p>
        <p style={{ fontSize: 14, color: '#888', margin: '0 0 36px' }}>
          {greeting} 🎉
        </p>

        <button
          onClick={onDismiss}
          style={{
            background: '#073E81', color: '#fff', border: 'none',
            borderRadius: 10, padding: '13px 40px', fontSize: 15,
            fontWeight: 600, cursor: 'pointer', transition: 'background 0.2s',
          }}
          onMouseEnter={e => e.target.style.background = '#052d5e'}
          onMouseLeave={e => e.target.style.background = '#073E81'}
        >
          Thank you! ✨
        </button>
      </div>
    </div>
  );
}
